import React, { useEffect, useState } from 'react';
import { getItem } from '../../controller/Control';
import { Upload, Modal, UploadFile, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { RcFile, UploadProps } from 'antd/es/upload/interface';
import axios from 'axios';

interface uploadProps {
  evolutionId: string;
}

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
});

const UploadImageWithPreview: React.FC<uploadProps> = ({evolutionId}) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
	const [imageData, setImageData] = useState<any>([])

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/imageUpload/${evolutionId}`, token)
		if(data && data.length > 0){
			setImageData(data)
		}else{
			setImageData([])
		}
	}

	useEffect(() => {getData()}, [0])
	useEffect(() => {getData()}, [evolutionId, fileList])

  // Función para mostrar la imagen en el modal cuando se previsualiza
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile); // Convertir a base64
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  // Función para actualizar la lista de archivos
  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);

	const handleUpload = async () => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const formData = new FormData();
		fileList.forEach((file) => {
			formData.append('file', file.originFileObj as RcFile);
		});
		formData.append('evolution_id', evolutionId)
	
		try {
			await axios.post(`${process.env.REACT_APP_API_SERVER}/imageUpload`, formData, {
				headers: {
					"Authorization": `Bearer ${token}`,
					'Content-Type': 'multipart/form-data'
				},
			});
			setFileList([])
			message.success('Imagen subida exitosamente');
		} catch (error) {
			message.error('Error subiendo la imagen');
		}
	};

	const openModalPreview = (url: string) => {
		setPreviewImage(`${process.env.REACT_APP_API_SERVER}/uploads/${url}`)
		setPreviewVisible(true)
	}

  return (
    <>
			<div className='flex flex-row flex-wrap'>
				{imageData.map((x:any, i:number) => {
					return(
					<div key={i} className='h-[200px] cursor-pointer mx-2' onClick={() => openModalPreview(x.image_url)}>
						<img className='h-[200px]' src={`${process.env.REACT_APP_API_SERVER}/uploads/${x.image_url}`}/>
					</div>
				)})}
			</div>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        beforeUpload={() => false} // Evita la subida automática para poder previsualizar
      >
        {fileList.length >= 8 ? null : (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Subir</div>
          </div>
        )}
      </Upload>
      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
			<div>
				<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3' type="button" onClick={handleUpload}>
					Agregar Imágenes
				</button>
			</div>
    </>
  );
};

export default UploadImageWithPreview;
